<div class="sub-header">
  <div class="container" style="height: 60px;">
    <div class="controls-panel">
      <div class="header">
        <h1>Native File System API</h1>
      </div>
    </div>
  </div>
</div>

<div class="report-header">
  <div class="container">

    <div class="install fail" *ngIf="!chromeAppInstalled">
      <fa name="fa fa-exclamation-triangle"></fa>
      <h3><span class="black">Native File System API</span> Disabled</h3>
    </div>

    <div class="install success" *ngIf="chromeAppInstalled">
      <fa name="fa fa-check-circle"></fa>
      <h3><span class="black">Native File System API</span> Enabled</h3>
    </div>

    <div class="install-guide">

      <h3>Setup Guide</h3>

      <div class="step">
        <p class="hd">
          Go to Chrome Flags setting by Copy/Pasting address below into address bar.
        </p>

        <div class="address">chrome://flags/#native-file-system-api</div>
      </div>

      <div class="step">
        <p class="hd">
          Lookup for <span class="hl-y">Native File System API</span> in Search bar, it will auto <span class="hl-y">highlight</span>.
        </p>
        <img src="/assets/images/ext_guide/fsapi_guide_1.png" />
      </div>

      <div class="step">
        <p class="hd">
          Choose Enabled from dropdown menu. Chrome will require restart upon selecting.
        </p>
        <img src="/assets/images/ext_guide/fpapi_guide_2.png" style="width: 600px;"/>
      </div>

      <div class="end"></div>

    </div>
  </div>
</div>
